import React from 'react'
import './section-border.css'

export default function SectionBorderPtBr() {
    return (
        <div className='Section-Border scroll_scale'></div>
    )
}
